import React, {useState} from "react";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import {Button, Header} from "@amzn/awsui-components-react";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import Input from "@amzn/awsui-components-react/polaris/input";

export interface SubmissionSearchPanelProps {
    searchHandler: (submissionId: string) => void;
}

const SubmissionSearchPanel: React.FC<SubmissionSearchPanelProps> = (props) => {
    const [submissionId, setSubmissionId] = useState<string>("")
    const formBody = (
        <>
        <FormField id="SubmissionSearchPanel-submissionId" label='Submission ID'>
            <Input
                autoFocus
                value={submissionId || ''}
                onChange={({detail}) => setSubmissionId(detail.value.trim())}
            />
        </FormField>
            <br/>
        <Button
            variant="primary"
            onClick={
                () => props.searchHandler(submissionId)
            }
        >
            Search
        </Button>
        </>
    )

    return (
        <>
            <ExpandableSection
                id='SubmissionSearchPanel'
                variant='container'
                header={<Header variant='h2'>Search</Header>}
                defaultExpanded>
                {formBody}
            </ExpandableSection>
            <br/>
        </>
    )

}

export default SubmissionSearchPanel
